<template>
  <div class="cta-input-color-group">
    <i class="cta-input-color-icon"></i>
    <input
      v-bind="$attrs"
      :value="value"
      v-on="inputListeners"
      class="cta-form-control"
      :data-testid="testid"
    >
  </div>
</template>

<script>
// This is essentially the same as color_input.vue, but this component
// emits events on itself. Not really sure why the other uses EventBus
export default {
  inheritAttrs: false,
  props: ['field_name', 'value', 'testid'],
  computed: {
    inputListeners: function () {
      var vm = this
      return Object.assign({},
        this.$listeners,
        {
          input: function (event) {
            vm.$emit(`update:${vm.field_name}`, event.target.value);
          },
          focusin: function(event) {
            vm.$emit(`toggle:picker`, true);
          },
          click: function (e) {
            e.stopPropagation();
          }
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/packs/application.scss";

.cta-form-control {
  border: 1px solid #e9ecef !important;
  text-shadow: none;
  box-shadow: none;
  background-color: $white;
  width: 100%;
  height: $cta-form-control-height;
  border: none;
  padding: 0 15px;
  border-radius: 5px;
  font-weight: 300;
  font-size: 16px;
  -webkit-transition: .4s;
  transition: .4s;
}
.cta-form-control:focus {
  box-shadow: unset;
  padding-left: 20px;
}

.cta-input-color-group {
  position: relative;

  .cta-input-color-icon {
    background: url('@img/icons-rainbow-circle.png') right no-repeat;
    position: absolute;
    width: 16px;
    height: 16px;
    top: $cta-form-control-height / 2 - (16px / 2);
    right: 15px;
  }
}
</style>
